import { PaginationOptions } from '@/interfaces/pagination-options'

export function tablePerPageOptions (): PaginationOptions {
  const options = {
    total: 0,
    currentPage: 1,
    pageSize: 20,
    align: 'right',
    size: 'small',
    perfect: true,
    pageSizes: [15, 20, 50],
    autoHidden: false,
    enabled: true
  }
  return options
}
